/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ICON_trainer': {
    width: 26,
    height: 33,
    viewBox: '0 0 26 33',
    data: '<path pid="0" d="M18.5 32l1-13.5 2 3.5-2.09 3.136a2.018 2.018 0 0 0 .26 2.535c.92.92 2.478.748 3.148-.367l1.73-2.885a5 5 0 0 0 .132-4.912l-1.772-3.346A5 5 0 0 0 18.49 13.5H16.5M7.5 32l-1-13.5-2 3.5 2.09 3.136c.53.793.413 1.86-.26 2.535-.92.92-2.478.748-3.148-.367l-1.73-2.885a5 5 0 0 1-.132-4.912l1.771-3.346a5 5 0 0 1 4.42-2.661H9.5m0 0l3.5 6.507M9.5 13.5h7M13 20.007l3.5-6.507M13 20.007c-1.38 0-2.5 1.112-2.5 2.493a2.5 2.5 0 1 0 5 0c0-1.38-1.12-2.493-2.5-2.493zM18 5.5a5 5 0 1 1-10 0 5 5 0 0 1 10 0z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/ICON_trainer.js